import React from 'react';

import AssetList from './AssetList';
import GroupOperation from './GroupOperation';
import { Asset, AssetId, Group, GroupId } from 'hooks/useGrouping';
import { TabChangeState, TAB_CHANGE_STATE } from 'pages/Grouping';

type GroupingTabSectionProps = {
  groupFilteredAssets: Asset[];
  currentGroup: Group;
  tabChangeState: TabChangeState;
  groups: Group[];
  editGroupName: (newName: string) => void;
  deleteGroup: () => void;
  changeGroup: (assetIds: AssetId[], groupId: GroupId) => void;
  finishTabChange: () => void;
};

const GroupingTabSection: React.FC<GroupingTabSectionProps> = props => {
  return (
    <>
      <GroupOperation
        currentGroup={props.currentGroup}
        isTabChanged={
          props.tabChangeState === TAB_CHANGE_STATE.TAB_CHANGE_FINISHED
        }
        editGroupName={props.editGroupName}
        deleteGroup={props.deleteGroup}
        groups={props.groups}
      />
      <AssetList
        groupFilteredAssets={props.groupFilteredAssets}
        isTabChanged={
          props.tabChangeState === TAB_CHANGE_STATE.TAB_CHANGE_FINISHED
        }
        isTabReady={props.tabChangeState === TAB_CHANGE_STATE.TAB_CHANGE_READY}
        groups={props.groups}
        changeGroup={props.changeGroup}
        currentGroupId={props.currentGroup.id}
        finishTabChange={props.finishTabChange}
      />
    </>
  );
};

export default GroupingTabSection;
